import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Divider from '@material-ui/core/Divider';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemButton from '@material-ui/core/Button';
import {  Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions,Button } from '@material-ui/core';
import Avatar from '@material-ui/core/Avatar';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
//    maxWidth: '36ch',
    backgroundColor: theme.palette.background.paper,
  },
  inline: {
    display: 'inline',
  }
}));
const formatCurrency = function(t){
    return '$'+new Number(t/100).toFixed(2);
}


export default function AlignItemsList(props) {
  const classes = useStyles();
  const [showDialog, setShowDialog] = useState(false);
  const ratingDialog = (<Dialog fullWidth open={showDialog} aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title"></DialogTitle>
      <DialogContent>
        This purchase is not yet supported on the phone app. Please log into Konstella.com on your pad/computer. Click the green Businesses link on the left-hand side to complete the purchase.
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setShowDialog(false)} color="primary">
          OK
       </Button>
      </DialogActions>
    </Dialog>);
  return (
    <List className={classes.root}>
    {ratingDialog}
      {props.items && props.items.map(item => (
        <ListItem alignItems="flex-start">
            <ListItemText secondary={formatCurrency(item.price) + ', ' + (item.howMany == -1 ? 'Unlimited' : (item.howMany + " Available"))}>{item.title}</ListItemText>
            <ListItemButton variant="contained" onClick={() => {setShowDialog(true)}}>Purchase</ListItemButton>
        <Divider variant="inset" component="li" />
      </ListItem>))}
    </List>
  );
}